<!-- Bootstrap Modal -->
<div
  class="modal fade"
  [class.show]="visible()"
  [style.display]="visible() ? 'block' : ''"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mapPointModalLabel"
  aria-hidden="true"
  id="mapPointModal"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="mapPointModalLabel">Add Map Point</h5>
        <span (click)="onCancel()" role="button" class="ms-auto">
          <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
        </span>
      </div>

      <div class="modal-body">
        <div class="popup-content">
          <div class="name-input-section">
            <label for="pointName" class="form-label">Point Name</label>
            <generic-dropdown
              [items]="lotsDD()"
              [label]="'Lots'"
              [allowSearch]="true"
              [clearable]="true"
              [placeholder]="'Select'"
              [(ngModel)]="selectedLot"
            >
            </generic-dropdown>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!selectedLot()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
@if (visible()) {
  <div class="modal-backdrop fade show" (click)="onCancel()"></div>
}
